/* eslint-disable */
import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// import voistrapHomeImg from '../../../../Assets/Images/Dashboard/Home.png';
// import voistrapMeetingsImg from '../../../../Assets/Images/Dashboard/Meetings.png';
// import voistrapPeopleImg from '../../../../Assets/Images/Dashboard/People.png';
// import voistrapScoreImg from '../../../../Assets/Images/Dashboard/Score.png';
import MediaQuery from 'react-responsive';
import HomeDesktopWhite from '../../../../Assets/Images/Dashboard/HomeDesktopWhite.jpeg';
import HomeDesktopDark from '../../../../Assets/Images/Dashboard/HomeDesktopDark.jpeg';
import ConfigurationDesktopDark from '../../../../Assets/Images/Dashboard/ConfigurationDesktopDark.jpeg';
import ConfigurationDesktopWhite from '../../../../Assets/Images/Dashboard/ConfigurationDesktopWhite.jpeg';
import OrdersTabletDark from '../../../../Assets/Images/Dashboard/OrdersTabletDark.jpeg';
import OrdersTabletWhite from '../../../../Assets/Images/Dashboard/OrdersTabletWhite.jpeg';
import CategoriesMobileDark from '../../../../Assets/Images/Dashboard/CategoriesMobileDark.jpeg';
import CategoriesMobileWhite from '../../../../Assets/Images/Dashboard/CategoriesMobileWhite.jpeg';
import device from '../../../../Assets/Responsive/breakpoints';

const HomeDesktopComp = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 15}%)`
  })
})`
  transition: transform 0.2s ease-out;
  position: absolute;
  bottom: -90vh;
  left: 0vw;
  height: 50vh;
  border-radius: 26px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  @media ${device.mobileMaxWidth} {
    transform-origin: left center;
    width: 100vw;
    height: 30vh;
    bottom: -30vh;
    border-radius: 12px;
  }
`;

const ConfigurationDesktopComp = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 8}%) scale(0.9)`
  })
})`
  transition: transform 0.2s ease-out;
  position: absolute;
  bottom: -70vh;
  left: 5vw;
  height: 50vh;
  border-radius: 26px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  /* filter: blur(0.6px); */
  @media ${device.mobileMaxWidth} {
    transform-origin: center;
    width: 100vw;
    height: 30vh;
    left: 0vw;
    bottom: -22vh;
    border-radius: 12px;
  }
`;

const OrdersTabletComp = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 4}%) scale(0.7)`
  })
})`
  transition: transform 0.2s ease-out;
  bottom: -90vh;
  right: 1vw;
  position: absolute;
  /* border: 1px dashed red; */
  height: 65vh;
  /* filter: blur(0.8px); */
  border-radius: 17px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  @media ${device.mobileMaxWidth} {
    transform-origin: right center;
    height: 55vh;
    right: 0vw;
    bottom: -65vh;
  }
`;

const CategoriesMobileComp = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 2}%) scale(0.6)`
  })
})`
  transition: transform 0.2s ease-out;
  bottom: -65vh;
  left: 9vw;
  position: absolute;
  /* border: 1px dashed red; */
  height: 70vh;
  /* filter: blur(1.2px); */
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  @media ${device.mobileMaxWidth} {
    transform-origin: left center;
    height: 60vh;
    left: 0vw;
    bottom: -65vh;
    border-radius: 32px;
  }
`;

class DashboardImages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homeMode: HomeDesktopDark,
      configurationMode: ConfigurationDesktopDark,
      OrdersTabletMode: OrdersTabletDark,
      categoriesMode: CategoriesMobileDark
    };
  }

  render() {
    let { scrollPercent } = this.props;
    const { boxHeight, index, scrollHeight, screenHeight } = this.props;
    const { homeMode, configurationMode, OrdersTabletMode, categoriesMode } = this.state;
    const heighttoBeReducedinVH = boxHeight * index - 100;
    const scrollOffset = (screenHeight * heighttoBeReducedinVH) / 100;
    const scrollOffsetInPercent = (scrollOffset * 100) / scrollHeight;
    scrollPercent -= scrollOffsetInPercent;
    return (
      <React.Fragment>
        {/* <OrdersMobileComp src={OrdersMobile} scroll={scrollPercent} alt="ordersMobile" /> */}
        <MediaQuery query="(max-device-width: 1224px)">
          <CategoriesMobileComp
            onClick={() =>
              categoriesMode === CategoriesMobileWhite
                ? this.setState({ categoriesMode: CategoriesMobileDark })
                : this.setState({ categoriesMode: CategoriesMobileWhite })
            }
            src={categoriesMode}
            scroll={scrollPercent}
            alt="CategoriesMobile"
          />

          <OrdersTabletComp
            onClick={() =>
              OrdersTabletMode === OrdersTabletWhite
                ? this.setState({ OrdersTabletMode: OrdersTabletDark })
                : this.setState({ OrdersTabletMode: OrdersTabletWhite })
            }
            src={OrdersTabletMode}
            scroll={scrollPercent}
            alt="sideBarTablet"
          />
          <ConfigurationDesktopComp
            onClick={() =>
              configurationMode === ConfigurationDesktopWhite
                ? this.setState({ configurationMode: ConfigurationDesktopDark })
                : this.setState({ configurationMode: ConfigurationDesktopWhite })
            }
            src={configurationMode}
            scroll={scrollPercent}
            alt="configurationDesktop"
          />
          <HomeDesktopComp
            onClick={() =>
              homeMode === HomeDesktopWhite
                ? this.setState({ homeMode: HomeDesktopDark })
                : this.setState({ homeMode: HomeDesktopWhite })
            }
            src={homeMode}
            scroll={scrollPercent}
            alt="homeDesktop"
          />
        </MediaQuery>
        <MediaQuery query="(min-device-width: 1224px)">
          <CategoriesMobileComp
            onMouseEnter={() => this.setState({ categoriesMode: CategoriesMobileWhite })}
            onMouseLeave={() => this.setState({ categoriesMode: CategoriesMobileDark })}
            onClick={() =>
              categoriesMode === CategoriesMobileWhite
                ? this.setState({ categoriesMode: CategoriesMobileDark })
                : this.setState({ categoriesMode: CategoriesMobileWhite })
            }
            src={categoriesMode}
            scroll={scrollPercent}
            alt="CategoriesMobile"
          />

          <OrdersTabletComp
            onMouseEnter={() => this.setState({ OrdersTabletMode: OrdersTabletWhite })}
            onMouseLeave={() => this.setState({ OrdersTabletMode: OrdersTabletDark })}
            onClick={() =>
              OrdersTabletMode === OrdersTabletWhite
                ? this.setState({ OrdersTabletMode: OrdersTabletDark })
                : this.setState({ OrdersTabletMode: OrdersTabletWhite })
            }
            src={OrdersTabletMode}
            scroll={scrollPercent}
            alt="sideBarTablet"
          />
          <ConfigurationDesktopComp
            onMouseEnter={() => this.setState({ configurationMode: ConfigurationDesktopWhite })}
            onMouseLeave={() => this.setState({ configurationMode: ConfigurationDesktopDark })}
            onClick={() =>
              configurationMode === ConfigurationDesktopWhite
                ? this.setState({ configurationMode: ConfigurationDesktopDark })
                : this.setState({ configurationMode: ConfigurationDesktopWhite })
            }
            src={configurationMode}
            scroll={scrollPercent}
            alt="configurationDesktop"
          />
          <HomeDesktopComp
            onMouseEnter={() => this.setState({ homeMode: HomeDesktopWhite })}
            onMouseLeave={() => this.setState({ homeMode: HomeDesktopDark })}
            onClick={() =>
              homeMode === HomeDesktopWhite
                ? this.setState({ homeMode: HomeDesktopDark })
                : this.setState({ homeMode: HomeDesktopWhite })
            }
            src={homeMode}
            scroll={scrollPercent}
            alt="homeDesktop"
          />
        </MediaQuery>
      </React.Fragment>
    );
  }
}

DashboardImages.propTypes = {
  boxHeight: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  screenHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollPercent: PropTypes.number.isRequired
};

export default DashboardImages;
